module.exports = __webpack_public_path__ + "static/media/AB.deeb21b0.webp";